export const SHOW_PASSCODE = 'SHOW_PASSCODE';
export const HIDE_PASSCODE = 'HIDE_PASSCODE';

export const PASSCODE_PASSED = 'PASSCODE_PASSED';



// WEBPACK FOOTER //
// ./src/app/passcode/constants.js